export const STATISTIC_DAY = 'day';

export const STATISTIC_BEFORE_EVENT = 'showBuild';